import { Grid, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TablePagination, TableRow, Typography, } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import BillingReportsService from "../../../Services/Reports/BillingReportsService";
import Home from "../../home/Home";
import { getDate } from "../../Utils/Common";
import Snackbar from '../../Snacbar'
import HashLoader from "react-spinners/HashLoader";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: 'black',
    textAlign: "center",    
    fontFamily: 'Times New Roman',
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontFamily: 'Times New Roman',
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: "100%",
  border: '1px solid black'
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: "100",
  border: '1px solid black'

}));

function BillDetailsReport() {
  const mystyle = {
    border: " 1px solid black",
    width: "9rem",
    fontFamily: 'Times New Roman',
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "#0b64c5",
    fontFamily: 'Times New Roman',
  };

  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState('');
  const [FilteredDetails, setFilteredDetails] = useState([]);

  const [details1, setdetails1] = useState([]);
  const [details2, setdetails2] = useState([]);
  const [details3, setdetails3] = useState([]);
  const [details4, setdetails4] = useState([]);
  const [details5, setdetails5] = useState([]);
  const [details6, setdetails6] = useState([]);
  const [details7, setdetails7] = useState([]);
  const [loading, setloading] = useState(false)
  const [BillRepValues, setBillRepValues] = useState({
    from: getDate(),
    to: getDate(),
    job: '',
    impnm: '-1',
    state: '-1',
    branch: '-1',
    fwnm: '-1',
    billby: '-1',
    billto: 'IMPORTER',
    ///summary
    totalJobNo: '0',
    taxablevalue: '0.00',
    cgstAmt: '0.00',
    sgstAmt: '0.00',
    igstAmt: '0.00',
    totalBillAmt: '0.00',
  });
  const fromhandlechange = (e) => {
    setBillRepValues({ ...BillRepValues, from: e.target.value })
  };
  const tohandlechange = (e) => {
    setBillRepValues({ ...BillRepValues, to: e.target.value })
  };
  const impnmhandlechange = (e) => {
    setBillRepValues({ ...BillRepValues, impnm: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const jobhandlechange = (e) => {
    setBillRepValues({ ...BillRepValues, job: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const statehandlechange = (e) => {
    setBillRepValues({ ...BillRepValues, state: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    var stateId = '';
    if (e.target.value === 'ALL') {
      stateId = '-1'
    } else {
      stateId = e.target.value
    }
    BillingReportsService.getRegionBasedOnState(stateId).then(res => {
      setdetails3(res.data)
    })
  };
  const branchhandlechange = (e) => {
    setBillRepValues({ ...BillRepValues, branch: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const fwnmhandlechange = (e) => {
    setBillRepValues({ ...BillRepValues, fwnm: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const billbyhandlechange = (e) => {
    setBillRepValues({ ...BillRepValues, billby: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const billtohandlechange = (e) => {
    setBillRepValues({ ...BillRepValues, billtoz: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  ///
  const [showProcs, setshowProcs] = useState(false)
  const [refreshProcs, setrefreshProcs] = useState(false)
  const [reportProcs, setreportProcs] = useState(false)
  ///dialogBox
  const handleClose = () => {
    setOpen(false)
  }
  //clearSummary
  const clearsummary = () => {
    setBillRepValues({ ...BillRepValues, totalJobNo: '0', taxablevalue: '0.00', cgstAmt: '0.00', sgstAmt: '0.00', igstAmt: '0.00', totalBillAmt: '0.00', })
  }
  ///getFunctions....
  const getImporterDetails = () => {
    BillingReportsService.getImporterDetail().then(res => {
      setdetails1(res.data);
    })
  }
  const getDeliveryStateNameAll = () => {
    BillingReportsService.getDeliveryStateNameAll().then(res => {
      setdetails2(res.data);
    })
  }
  const getbranchbasedonState = () => {
    BillingReportsService.getRegionBasedOnState('-1').then(res => {
      setdetails3(res.data)
    })
  }
  const getforwarder = () => {
    BillingReportsService.selectFwdDetails().then(res => {
      setdetails4(res.data);
    })
  }
  const getbillpaidby = () => {
    BillingReportsService.selectBillPaidBy().then(res => {
      setdetails5(res.data);
    })
  }
  const getbillprintto = () => {
    BillingReportsService.getBillPaidToSelective().then(res => {
      setdetails6(res.data);
    })
  }
  //btnOperation
  const showBtnclick = () => {
    setloading(true)
    setshowProcs(true)
    setPage(0)
    setdetails7([])
    setFilteredDetails([])
    clearsummary();
    var billto, jobNo = '';
    if (BillRepValues.billto === 'FORWARDER') {
      billto = '2'
    } else if (BillRepValues.billto === 'IMPORTER') {
      billto = '1'
    } else {
      billto = '-1'
    }
    if (BillRepValues.job === '' || !BillRepValues.job) {
      jobNo = '-1'
    } else {
      jobNo = BillRepValues.job;
    }
    let details = {
      fromDate: BillRepValues.from, toDate: BillRepValues.to, consignmentId: jobNo,
      iecNo: BillRepValues.impnm, fwdcode: BillRepValues.fwnm, billPaidBy: BillRepValues.billby,
      billPaidTo: billto, deliveryStateId: BillRepValues.state, branchId: BillRepValues.branch
    }
    BillingReportsService.reportBillingDetails(details).then(res => {
      const data = res.data;
      const details = data.map((item) => item)
      if (details[0] === [] || !details[0]) {
        setMessage('No Data Found!!')
        setseverit('warning')
        setOpen(true)
        setshowProcs(false)
        setloading(false)
      } else {
        var totaljob = 0, valueTaxableAmount = 0, valueCGSTamount = 0, valueSGSTamount = 0, valueIGSTamount = 0, valueTotalBillAmount = 0
        var jobCount = 0;
        var valueJob = "";
        for (let i = 0; i < details.length; i++) {
          if (details[i].consignmentId !== valueJob) {
            jobCount += 1;
            valueJob = details[i].consignmentId;
          }
          totaljob = jobCount;
          valueTaxableAmount += details[i].billAmount
          valueCGSTamount += details[i].cgstAmt
          valueSGSTamount += details[i].sgstAmt
          valueIGSTamount += details[i].igstAmt
          valueTotalBillAmount = valueTaxableAmount + valueIGSTamount
        }
        setBillRepValues({
          ...BillRepValues, totalJobNo: totaljob, taxablevalue: valueTaxableAmount.toFixed(2), cgstAmt: valueCGSTamount.toFixed(2),
          sgstAmt: valueSGSTamount.toFixed(2), igstAmt: valueIGSTamount.toFixed(2), totalBillAmt: valueTotalBillAmount.toFixed(2)
        })
        setdetails7(res.data);
        setFilteredDetails(res.data);
        setshowProcs(false)
        setloading(false)
      }
    })
  }
  const refreshBtnclick = () => {
    setrefreshProcs(true)
    setPage(0)
    setBillRepValues({
      ...BillRepValues, from: getDate(), to: getDate(), job: '', impnm: '-1', state: '-1', branch: '-1', fwnm: '-1', billby: '-1', billto: '', totalJobNo: '0',
      taxablevalue: '0.00',
      cgstAmt: '0.00',
      sgstAmt: '0.00',
      igstAmt: '0.00',
      totalBillAmt: '0.00',
    })
    setdetails7([]);
    setFilteredDetails([]);
    getbranchbasedonState();
    setrefreshProcs(false)
    setshowProcs(false)
  }
  const reportBtnclick = () => {
    setreportProcs(true)
    if (!details7[0]) {
      setMessage('No Record Found')
      setseverit('warning')
      setOpen(true)
    } else {
      var tableContent, contenall = '';
      for (let i = 0; i < details7.length; i++) {
        if (details7[i].consignmentId !== '') {
          tableContent = details7[i].consignmentId + "!"
        } else {
          tableContent += '   !'
        }
        if (details7[i].invoiceNo !== '') {
          tableContent += details7[i].invoiceNo + "!"
        }
        else {
          tableContent += '  !';
        }
        if (details7[i].invoiceDate !== '') {
          tableContent += details7[i].invoiceDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].iecName !== '') {
          tableContent += details7[i].iecName + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].fwdName !== '') {
          tableContent += details7[i].fwdName + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].partyName !== '') {
          tableContent += details7[i].partyName + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].partyGstin !== '') {
          tableContent += details7[i].partyGstin + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].partyStateCode !== '') {
          tableContent += details7[i].partyStateCode + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].billPaidBy !== '') {
          tableContent += details7[i].billPaidBy + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].billPaidDate !== '') {
          tableContent += details7[i].billPaidDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].paymentType !== '') {
          tableContent += details7[i].paymentType + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].voucherType !== '') {
          tableContent += details7[i].voucherType + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].printedType !== '') {
          tableContent += details7[i].printedType + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].billName !== '') {
          tableContent += details7[i].billName + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].hsnCode !== '') {
          tableContent += details7[i].hsnCode + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].billAmount !== '') {
          tableContent += details7[i].billAmount + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].cgstRate !== '') {
          tableContent += details7[i].cgstRate + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].cgstAmt !== '') {
          tableContent += details7[i].cgstAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].sgstRate !== '') {
          tableContent += details7[i].sgstRate + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].sgstAmt !== '') {
          tableContent += details7[i].sgstAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].igstRate !== '') {
          tableContent += details7[i].igstRate + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].igstAmt !== '') {
          tableContent += details7[i].igstAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details7[i].totalBillAmount !== '') {
          tableContent += details7[i].totalBillAmount + "#"
        } else {
          tableContent += '  #';
        }
        contenall += tableContent;
      }
      // console.log('contenall => '+JSON.stringify(contenall))
      let details = {
        headerName: "3,0,DAILY BILL DETAILS REPORT", headerDetails: "1,1,FROM DATE : " + BillRepValues.from + "/4,1,TO DATE : " + BillRepValues.to,
        tableHeader: "0,3,Sl.No/1,3,Job No/2,3,Invoice No/3,3,Invoice Date/4,3,Importer Name/5,3,Forwarder Name/6,3,Party Name/7,3,Party Gstin/8,3,Party State/9,3,paid By/10,3,Paid Date/11,3,Payment Type/12,3,Voucher Type/13,3,Printed Type/14,3,Description/15,3,HSN Code/16,3,Taxable Value/17,3,CGST Rate/18,3,CGST Amount/19,3,SGST Rate/20,3,SGST Amount/21,3,IGST Rate/22,3,IGST Amount/23,3,Total Bill Amount",
        tableRowStartsFrom: 4, tableColumnStartsFrom: 0, fileCode: "dbd", totalNumberOfColumn: 24, tableContent: contenall.substring(0, contenall.length - 1),
      }
      BillingReportsService.Excelwrite(details).then((res) => {
        const filename = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank")
        window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");

      })
    }
    setreportProcs(false)
  }
  ///
  useEffect(() => {
    setloading(true)
    setTimeout(() => {
      setloading(false)
    }, 1000)
    getImporterDetails();
    getDeliveryStateNameAll();
    getbranchbasedonState();
    getforwarder();
    getbillpaidby();
    getbillprintto();
  }, [])

  //table search  
  const jobnoSrch = () => {
    return <input style={{ width: '60px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { jobNoOnchange(e.target.value) }} />
  }
  const invoiceNoSrch = () => {
    return <input placeholder="Search" style={{ width: '60px', textAlign: 'center', fontSize: '12px' }}
      onChange={(e) => { invoiceNoOnchange(e.target.value) }} />
  }
  const impNameSrch = () => {
    return <input placeholder="Search" style={{ width: '60px', textAlign: 'center', fontSize: '12px' }}
      onChange={(e) => { impnameOnchange(e.target.value) }} />
  }
  const forwarderNmSrch = () => {
    return <input placeholder="Search" style={{ width: '60px', textAlign: 'center', fontSize: '12px' }}
      onChange={(e) => { forwarderNmOnchange(e.target.value) }} />
  }
  const partyNameSrch = () => {
    return <input placeholder="Search" style={{ width: '60px', textAlign: 'center', fontSize: '12px' }}
      onChange={(e) => { partynameOnchange(e.target.value) }} />
  }
  const partystateSrch = () => {
    return <input placeholder="Search" style={{ width: '60px', textAlign: 'center', fontSize: '12px' }}
      onChange={(e) => { partystateOnchange(e.target.value) }} />
  }
  const paymentTypsrch = () => {
    return <input placeholder="Search" style={{ width: '60px', textAlign: 'center', fontSize: '12px' }}
      onChange={(e) => { paymentTypOnchange(e.target.value) }} />
  }
  const branchNmSrch = () => {
    return <input placeholder="Search" style={{ width: '60px', textAlign: 'center', fontSize: '12px' }}
      onChange={(e) => { branchNmOnchange(e.target.value) }} />
  }
  const stateNameSrch = () => {
    return <input placeholder="Search" style={{ width: '60px', textAlign: 'center', fontSize: '12px' }}
      onChange={(e) => { stateNmOnchange(e.target.value) }} />
  }

  const jobNoOnchange = (searchedVal) => {
    const filteredvalue = details7.filter((trns) => {
      return trns.consignmentId.toString().toLowerCase().includes(searchedVal.toLowerCase());
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details7)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const invoiceNoOnchange = (searchedVal) => {
    const filteredvalue = details7.filter((trns) => {
      return trns.invoiceNo.toString().toLowerCase().includes(searchedVal.toLowerCase());
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details7)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const impnameOnchange = (searchedVal) => {
    const filteredvalue = details7.filter((trns) => {
      return trns.iecName.toString().toLowerCase().includes(searchedVal.toLowerCase());
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details7)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const forwarderNmOnchange = (searchedVal) => {
    const filteredvalue = details5.filter((trns) => {
      return trns.fwdName.toString().toLowerCase().includes(searchedVal.toLowerCase());
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details7)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const partynameOnchange = (searchedVal) => {
    const filteredvalue = details7.filter((trns) => {
      return trns.partyName.toString().toLowerCase().includes(searchedVal.toLowerCase());
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details7)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const partystateOnchange = (searchedVal) => {
    const filteredvalue = details7.filter((trns) => {
      return trns.partyStateCode.toString().toLowerCase().includes(searchedVal.toLowerCase());
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details7)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const paymentTypOnchange = (searchedVal) => {
    const filteredvalue = details7.filter((trns) => {
      return trns.paymentType.toString().toLowerCase().includes(searchedVal.toLowerCase());
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details7)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const branchNmOnchange = (searchedVal) => {
    const filteredvalue = details7.filter((trns) => {
      return trns.brName.toString().toLowerCase().includes(searchedVal.toLowerCase());
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details7)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const stateNmOnchange = (searchedVal) => {
    const filteredvalue = details7.filter((trns) => {
      return trns.deliveryStateName.toString().toLowerCase().includes(searchedVal.toLowerCase());
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details7)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }
  return (
    <div>
      <Home />
      <div style={{ paddingLeft: '80px' }}>
        {/* /errorbox// */}
        <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
        {/* /// */}
        {loading ?
          <div className="loaderCss">
            <HashLoader
              color={"#296cbc"}
              loading={loading}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div> :
          <ItemPap>
            <Grid container>
              <Grid item xs={8}>
                <div className='Billingtitleclr' style={{fontFamily: 'Times New Roman', color: 'red', fontWeight: 'bold', fontSize: '25px', marginTop: '1%', marginBottom: '1%', }}><center>BILL DETAILS REPORT</center></div>
                <Row>
                  <Col xs={3}>
                    <label style={mystyle1}>FromDate</label>
                  </Col>
                  <Col>
                    <Form.Control size="sm" type="date" style={mystyle} value={BillRepValues.from} onChange={fromhandlechange} />
                  </Col>
                  <Col>
                    <label style={mystyle1}>ToDate</label>
                  </Col>
                  <Col>
                    <Form.Control size="sm" type="date" style={mystyle} value={BillRepValues.to} onChange={tohandlechange} />
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col xs={3}>
                    <label style={mystyle1}>Job_No</label>
                  </Col>
                  <Col>
                    <Form.Control
                      size="sm"
                      type="text"
                      style={mystyle} value={BillRepValues.job} onChange={jobhandlechange}
                    ></Form.Control>
                  </Col>
                  <Col>
                    <label style={mystyle1}>ImporterName</label>
                  </Col>
                  <Col>
                    <Form.Select size="sm" style={mystyle} value={BillRepValues.impnm} onChange={impnmhandlechange} >
                      <option value={'-1'}>ALL</option>
                      {details1.map(trns => (
                        <option value={trns.importer_iec_no}>{trns.importer_name}</option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col xs={3}>
                    <label style={mystyle1}>StateName</label>
                  </Col>
                  <Col>
                    <Form.Select size="sm" style={mystyle} value={BillRepValues.state} onChange={statehandlechange} >
                      <option value={'-1'}>ALL</option>
                      {details2.map(trns => (
                        <option value={trns.deliveryStateId}>{trns.deliveryStateName}</option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col>
                    <label style={mystyle1}>BranchName</label>
                  </Col>
                  <Col>
                    <Form.Select size="sm" style={mystyle} value={BillRepValues.branch} onChange={branchhandlechange} >
                      <option value={'-1'}>ALL</option>
                      {details3.map(trns => (
                        <option value={trns.regionId}>{trns.regionName}</option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col xs={3}>
                    <label style={mystyle1}>ForwarderName</label>
                  </Col>
                  <Col>
                    <Form.Select size="sm" style={mystyle} value={BillRepValues.fwnm} onChange={fwnmhandlechange} >
                      <option value={'-1'}>ALL</option>
                      {details4.map(trns => (
                        <option value={trns.fwdId}>{trns.fwdName}</option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col>
                    <label style={mystyle1}>BillPaid_By</label>
                  </Col>
                  <Col>
                    <Form.Select size="sm" style={mystyle} value={BillRepValues.billby} onChange={billbyhandlechange} >
                      <option value={'-1'}>ALL</option>
                      {details5.map(trns => (
                        <option value={trns.billPaidBy}>{trns.billPaidBy}</option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col xs={3}>
                    <label style={mystyle1}>BillPrint_To</label>
                  </Col>
                  <Col>
                    <Form.Select size="sm" style={mystyle} value={BillRepValues.billto} onChange={billtohandlechange} >
                      {details6.map(trns => (
                        <option value={trns.billPaidTo}>{trns.billPaidTo}</option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col lg={4}></Col>
                </Row>
                <center>
                  <Col lg={5} className="mt-2 mb-2">
                    <Button variant="success" style={{fontFamily: 'Times New Roman'}} size="sm" onClick={showBtnclick}>{showProcs ? 'processing...' : 'Show'}</Button>{" "}
                    <Button variant="warning" style={{fontFamily: 'Times New Roman'}}size="sm" onClick={refreshBtnclick}>{refreshProcs ? 'processing...' : 'Refresh'}  </Button>{" "}
                    <Button variant="primary" style={{fontFamily: 'Times New Roman'}}size="sm" onClick={reportBtnclick}>{reportProcs ? 'processing...' : 'Report'}  </Button>
                  </Col>
                </center>
              </Grid>
              <Grid item xs={4}>
                <ItemPap1>
                  <Typography style={{fontFamily: 'Times New Roman',}} color={"darkblue"} fontWeight={"bolder"} variant={"h6"}> Summary </Typography>
                  <Row>
                    <Col xs={3} ><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>TotalJobNo</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{BillRepValues.totalJobNo}</Form.Label></Col>
                  </Row>
                  <Row>
                    <Col xs={3} ><Form.Label style={{ fontFamily: 'Times New Roman',justifyContent: 'left', color: "black", fontWeight: "bolder", }}>TaxableValue</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{ fontFamily: 'Times New Roman',justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{BillRepValues.taxablevalue}</Form.Label></Col>
                  </Row>
                  <Row>
                    <Col xs={3} ><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}> CGSTAmount</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{BillRepValues.cgstAmt}</Form.Label></Col>
                  </Row>
                  <Row>
                    <Col xs={3} ><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}> SGSTAmount</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{BillRepValues.sgstAmt}</Form.Label></Col>
                  </Row>
                  <Row>
                    <Col xs={3} ><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}> IGSTAmount</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{BillRepValues.igstAmt}</Form.Label></Col>
                  </Row>
                  <Row>
                    <Col xs={3} ><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>TotalBilling Amount</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{ fontFamily: 'Times New Roman',justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{BillRepValues.totalBillAmt}</Form.Label></Col>
                  </Row>
                </ItemPap1>
              </Grid>
            </Grid>
            <ItemPap1>
              <TableContainer sx={{ height: 340 }} className="mt-1">
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>SlNo</StyledTableCell>
                      <StyledTableCell>JobNo{jobnoSrch()}</StyledTableCell>
                      <StyledTableCell>InvoiceNo{invoiceNoSrch()}</StyledTableCell>
                      <StyledTableCell>InvoiceDate</StyledTableCell>
                      <StyledTableCell>ImporterName{impNameSrch()}</StyledTableCell>
                      <StyledTableCell>ForwarderName{forwarderNmSrch()}</StyledTableCell>
                      <StyledTableCell>PartyName{partyNameSrch()}</StyledTableCell>
                      <StyledTableCell>PartyGSTIN</StyledTableCell>
                      <StyledTableCell>PartyState{partystateSrch()}</StyledTableCell>
                      <StyledTableCell>TaxableValue</StyledTableCell>
                      <StyledTableCell>Description</StyledTableCell>
                      <StyledTableCell>HSN_Code</StyledTableCell>
                      <StyledTableCell>CGST_Rate</StyledTableCell>
                      <StyledTableCell>CGST_Amount</StyledTableCell>
                      <StyledTableCell>SGST_Rate</StyledTableCell>
                      <StyledTableCell>SGST_Amount</StyledTableCell>
                      <StyledTableCell>IGST_Rate</StyledTableCell>
                      <StyledTableCell>IGST_Amount</StyledTableCell>
                      <StyledTableCell>TotalBillAmount</StyledTableCell>
                      <StyledTableCell>Paid_By</StyledTableCell>
                      <StyledTableCell>BillPaid_date</StyledTableCell>
                      <StyledTableCell>Payment_Type{paymentTypsrch()}</StyledTableCell>
                      <StyledTableCell>Voucher_Type</StyledTableCell>
                      <StyledTableCell>Printed_Type</StyledTableCell>
                      <StyledTableCell>State_Name{stateNameSrch()}</StyledTableCell>
                      <StyledTableCell>Branch_Name{branchNmSrch()}</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {FilteredDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((trns, index) => (
                        <TableRow hover key={trns.serialNumber}>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.serialNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.consignmentId}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.iecName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.fwdName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.partyName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.partyGstin}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.partyStateCode}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.billAmount}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.billName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.hsnCode}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.cgstRate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.cgstAmt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.sgstRate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.sgstAmt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.igstRate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.igstAmt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totalBillAmount}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.billPaidBy}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.billPaidDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.paymentType}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.voucherType}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.printedType}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.deliveryStateName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.brName}</StyledTableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                showFirstButton
                showLastButton
                component='div'
                count={FilteredDetails.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onChangeRowsPerpage={handleChangeRowsPerPage}
              />
            </ItemPap1>
          </ItemPap>
        }
      </div>
    </div>
  );
}

export default BillDetailsReport;
